<script setup>
import { computed, ref, watchEffect } from 'vue';
let props = defineProps({
	isSearching: {
		type: Boolean,
		default: false
	},
	data: {
		type: [Object, null],
		required: true,
		default: {}
	},
	topHit: {
		type: [Object, null],
		required: true,
		default: {}
	},
	suggestions: {
		type: [Array, null],
		required: false,
		default: []
	},
	searchPageUrl: {
		type: String,
		required: true
	}
});

const DEFAULT_GROUP = 'Pages';

let rows = computed(() => {
	let documents = props.data?.TypedDocuments ?? [];

	return documents
		.sort((a, b) => a.Score < b.Score)
		.reduce((carry, document) => {
			let groupingTitle = document.Fields?.['GroupingTitle']?.Value ?? DEFAULT_GROUP;
			let found = carry.find((c) => c.title === groupingTitle);

			let documentData = {
				score: document.Score,
				url: document.Fields.Url.Value,
				title: document.Fields.Title.Value
			};

			if (found) {
				found.items.push(documentData);

				return carry;
			}

			carry.push({
				title: groupingTitle,
				items: [documentData]
			});

			return carry;
		}, [])
		.map((row) => {
			row.items = row.items.slice(0, 5);

			return row;
		});
});

const resultCount = computed(() => props?.data?.TotalDocument);

const emit = defineEmits(['suggestion-clicked']);

function onSuggestionClicked(event, item) {
	event.preventDefault();
	event.stopPropagation();
	event.stopImmediatePropagation();

	emit('suggestion-clicked', item);
}
</script>

<template>
	<div class="search-drawer-listing js-click-ignore">
		<div v-if="suggestions?.length" class="search-drawer-listing__item">
			<h2 class="search-drawer-listing__item-title">Search Suggestions</h2>
			<ul class="search-drawer-listing__suggestions-list">
				<li
					class="search-drawer-listing__suggestions-list-item"
					v-for="item in suggestions"
				>
					<button
						class="search-drawer-listing__suggestions-list-btn"
						type="button"
						v-text="item"
						@click="(event) => onSuggestionClicked(event, item)"
					></button>
				</li>
			</ul>
		</div>

		<div v-if="props.topHit.value" class="search-drawer-listing__item">
			<h2 class="search-drawer-listing__item-title">Top Hit</h2>
			<ul class="search-drawer-listing__suggestions-list">
				<li class="search-drawer-listing__suggestions-list-item">
					<a
						class="search-drawer-listing__item-list-link"
						:href="props.topHit.value"
						v-text="props.topHit.value"
					></a>
				</li>
			</ul>
		</div>

		<div class="search-drawer-listing__item-title" v-if="isSearching">Searching...</div>
		<template v-else-if="resultCount">
			<div class="search-drawer-listing__item" v-for="(group, rowIndex) in rows">
				<h2 class="search-drawer-listing__item-title" v-text="group.title"></h2>

				<ul class="search-drawer-listing__item-list">
					<li
						class="search-drawer-listing__item-list-item"
						v-for="(item, itemIndex) in group.items"
					>
						<h3 class="search-drawer-listing__item-list-title" v-text="item.title"></h3>
						<a
							class="search-drawer-listing__item-list-link"
							:href="item.url"
							v-text="item.url"
						></a>
					</li>
				</ul>
			</div>
			<div class="search-drawer-listing__item">
				<div>
					<a class="search-drawer__btn" :href="searchPageUrl">
						View Full Search Results
					</a>
				</div>
			</div>
		</template>
		<div class="search-drawer-listing__item-title" v-else-if="data">No Results</div>
	</div>
</template>
